import { Component } from 'react';
import { Box } from 'components/common';
import { ELSSlideSwitch } from 'components/common/els';
import './barcode-toggle.scss';

interface BarcodeToggleProps {
  barcodeEnabled: boolean;
  onChange?: (enabled: boolean) => void;
  showViewLink?: boolean;
  disabled?: boolean;
  onViewClick?: () => void;
}

class BarcodeToggle extends Component<BarcodeToggleProps> {
  static displayName = 'BarcodeToggle';

  handleToggleChange = (_event, checked: boolean) => {
    if (this.props.onChange) {
      this.props.onChange(checked);
    }
  };

  render() {
    const { barcodeEnabled, showViewLink, disabled, onViewClick } = this.props;

    return (
      <Box className="barcode-toggle" my2>
        <ELSSlideSwitch
          id="barcode-toggle"
          name="barcodeEnabled"
          checked={barcodeEnabled}
          changeHandler={this.handleToggleChange}
          labelStateIsOn="Barcoding On"
          labelStateIsOff="Barcoding Off"
          isDisabled={disabled}
        />
        {barcodeEnabled && showViewLink && (
          <Box mt className="barcode-toggle__link">
            <button
              type="button"
              onClick={() => {
                if (onViewClick) {
                  onViewClick();
                }
              }}
              className="u-els-anchorize"
            >
              View and Print Barcodes
            </button>
          </Box>
        )}
      </Box>
    );
  }
}

export { BarcodeToggle as BaseBarcodeToggle };
export default BarcodeToggle;
